import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NDDCoreModule } from '@ndk/ng-core';
import { NDDTranslationModule } from '@ndk/ng-translation';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { NDDIntlModule } from 'ndd-ng-intl';
import { NDDKendoTranslationModule } from 'ndd-ng-kendo-translation';

import { CustomDialogModule } from '@shared/overrides/custom-dialog.module';

import { NDDFormCheckboxComponent } from './ndd-ng-form-checkbox/ndd-ng-form-checkbox.component';
import { NDDFormDatePickerComponent } from './ndd-ng-form-dateinputs/ndd-ng-form-datepicker/ndd-ng-form-datepicker.component';
import { NDDFormTimePickerComponent } from './ndd-ng-form-dateinputs/ndd-ng-form-timepicker/ndd-ng-form-timepicker.component';
import { NDDFormDropDownListComponent } from './ndd-ng-form-dropdowns/ndd-ng-form-dropdownlist/ndd-ng-form-dropdownlist.component';
import { NDDFormPopupComponent } from './ndd-ng-form-dropdowns/ndd-ng-form-popup/ndd-ng-form-popup.component';
import { NDDFormErrorComponent } from './ndd-ng-form-error/ndd-ng-form-error.component';
import { NDDFormErrorService } from './ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormFieldsetComponent } from './ndd-ng-form-fieldset/ndd-ng-form-fieldset.component';
import { NDDFormInputComponent } from './ndd-ng-form-input/ndd-ng-form-input.component';
import { NDDFormLabelComponent } from './ndd-ng-form-label/ndd-ng-form-label.component';
import { NDDFormNumericComponent } from './ndd-ng-form-numeric/ndd-ng-form-numeric.component';
import { NDDFormPasswordComponent } from './ndd-ng-form-password/ndd-ng-form-password.component';
import { NDDFormRadioBtnGroupComponent } from './ndd-ng-form-radio-btn-group/ndd-ng-form-radio-btn-group.component';
import { NDDFormRadioBtnComponent } from './ndd-ng-form-radio-btn/ndd-ng-form-radio-btn.component';
import { NDDFormRadioComponent } from './ndd-ng-form-radio/ndd-ng-form-radio.component';
import { NDDFormTextAreaComponent } from './ndd-ng-form-textarea/ndd-ng-form-textarea.component';
import { NDDFormComponent } from './ndd-ng-form/ndd-ng-form.component';
import { NDDFormsFocusDirective } from './shared/ndd-ng-forms-focus.directive';
import { NDDFormsGuardService } from './shared/ndd-ng-forms-guard.service';
import { NDDFormsI18nService } from './shared/ndd-ng-forms-i18n.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        DateInputsModule,

        NDDCoreModule,
        NDDIntlModule,
        NDDTranslationModule,
        NDDKendoTranslationModule,
        CustomDialogModule,
    ],
    exports: [
        NDDFormsFocusDirective,
        NDDFormComponent,
        NDDFormLabelComponent,
        NDDFormCheckboxComponent,
        NDDFormRadioComponent,
        NDDFormRadioBtnComponent,
        NDDFormRadioBtnGroupComponent,
        NDDFormInputComponent,
        NDDFormPasswordComponent,
        NDDFormTextAreaComponent,
        NDDFormNumericComponent,
        NDDFormFieldsetComponent,
        NDDFormDropDownListComponent,
        NDDFormDatePickerComponent,
        NDDFormTimePickerComponent,
    ],
    declarations: [
        NDDFormsFocusDirective,
        NDDFormComponent,
        NDDFormErrorComponent,
        NDDFormLabelComponent,
        NDDFormCheckboxComponent,
        NDDFormRadioComponent,
        NDDFormRadioBtnComponent,
        NDDFormRadioBtnGroupComponent,
        NDDFormInputComponent,
        NDDFormPasswordComponent,
        NDDFormTextAreaComponent,
        NDDFormNumericComponent,
        NDDFormFieldsetComponent,
        NDDFormPopupComponent,
        NDDFormDropDownListComponent,
        NDDFormDatePickerComponent,
        NDDFormTimePickerComponent,
    ],
    providers: [
        NDDFormsI18nService,
        NDDFormsGuardService,
        NDDFormErrorService,
    ],
})
export class NDDFormsModule { }
